import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import './index.css'
import { STORAGE_KEYS } from './services/storageKeys'
import { safeStorage } from './services/safeStorage'
import { FavoritesProvider } from './contexts/FavoritesContext'

const applyTheme = (theme: 'light' | 'dark' | 'system') => {
  const root = document.documentElement
  root.classList.remove('light', 'dark', 'system')
  root.classList.add(theme)
}

const themeResult = safeStorage.getString(STORAGE_KEYS.THEME)
const savedTheme = themeResult.ok ? themeResult.value : null

if (!savedTheme) {
  // No preference set — default to dark mode.
  safeStorage.setString(STORAGE_KEYS.THEME, 'dark')
  applyTheme('dark')
} else if (savedTheme === 'dark' || savedTheme === 'light') {
  applyTheme(savedTheme)
}
// For 'system' the useTheme hook applies the OS-level preference.

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Failed to find the root element')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <FavoritesProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FavoritesProvider>
    </I18nextProvider>
  </React.StrictMode>,
)
